import { render, staticRenderFns } from "./v-map-addon-island-dialog.vue?vue&type=template&id=cf49215e&scoped=true"
import script from "./v-map-addon-island-dialog.vue?vue&type=script&lang=js"
export * from "./v-map-addon-island-dialog.vue?vue&type=script&lang=js"
import style0 from "./v-map-addon-island-dialog.vue?vue&type=style&index=0&id=cf49215e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf49215e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf49215e')) {
      api.createRecord('cf49215e', component.options)
    } else {
      api.reload('cf49215e', component.options)
    }
    module.hot.accept("./v-map-addon-island-dialog.vue?vue&type=template&id=cf49215e&scoped=true", function () {
      api.rerender('cf49215e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-addon/addon/v-map-addon-island-dialog.vue"
export default component.exports